<template>
    <b-row>
        <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
            <b-row>
                <label class="sa-label-data"> 2) TRATTAMENTO SOCIO-RIABILITATIVO</label>
            </b-row>
            <b-row>
                <b-col v-if="!isReadOnly" cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                    <label class="sa-label-data">Data Inizio</label>
                    <date-picker v-if="!isReadOnly" v-model="jsonData.dataInizio" format="DD-MM-YYYY" value-type="timestamp" type="date" placeholder="Seleziona una data inizio"></date-picker>
                </b-col>
                <b-col v-if="!isReadOnly" cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                    <label class="sa-label-data">Data Fine</label>
                    <date-picker v-model="jsonData.dataFine" format="DD-MM-YYYY" value-type="timestamp" type="date" placeholder="Seleziona una data fine"></date-picker>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                    <label class="sa-label-data">Colloqui periodici con i familiari:</label>
                    <b-form-select v-if="!isReadOnly" v-model="jsonData.colloquiPeriodiciConFamiliari" :options="options" text-field="text" value-field="value"> </b-form-select>
                    <span v-else>{{ jsonData.colloquiPeriodiciConFamiliari }}</span>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                    <label class="sa-label-data">Dettaglio:</label>
                    <b-form-input v-if="!isReadOnly" v-model="jsonData.colloquiPeriodiciConFamiliariDettaglio" :readonly="isReadOnly" :disabled="jsonData.colloquiPeriodiciConFamiliari !== 'SI'"></b-form-input>
                    <span v-else>{{ jsonData.colloquiPeriodiciConFamiliariDettaglio }}</span>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                    <label class="sa-label-data">ATTIVITA' DI INCLUSIONE SOCIALE INTEGRATA</label>
                    <b-form-select v-if="!isReadOnly" v-model="jsonData.attivitaInclusioneSocialeIntegrata" :options="options" text-field="text" value-field="value"> </b-form-select>
                    <span v-else>{{ jsonData.attivitaInclusioneSocialeIntegrata }}</span>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                    <label class="sa-label-data">Riprendere gli studi/conseguire la licenza media inferiore o laurea:</label>
                    <b-form-select :disabled="jsonData.attivitaInclusioneSocialeIntegrata !== 'SI'" v-if="!isReadOnly" v-model="jsonData.riprendereStudiConseguireLicenza" :options="options" text-field="text" value-field="value"></b-form-select>
                    <span v-else>{{ jsonData.riprendereStudiConseguireLicenza }}</span>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                    <label class="sa-label-data">Dettaglio:</label>
                    <b-form-input v-if="!isReadOnly" v-model="jsonData.riprendereStudiConseguireLicenzaDettaglio" :readonly="isReadOnly" :disabled="jsonData.riprendereStudiConseguireLicenza !== 'SI'"></b-form-input>
                    <span v-else>{{ jsonData.riprendereStudiConseguireLicenzaDettaglio }}</span>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                    <label class="sa-label-data">Conseguire la patente di guida:</label>
                    <b-form-select :disabled="jsonData.attivitaInclusioneSocialeIntegrata !== 'SI'" v-if="!isReadOnly" v-model="jsonData.coneguirePatenteGuida" :options="options" text-field="text" value-field="value"></b-form-select>
                    <span v-else>{{ jsonData.coneguirePatenteGuida }}</span>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                    <label class="sa-label-data">Dettaglio:</label>
                    <b-form-input v-if="!isReadOnly" v-model="jsonData.coneguirePatenteGuidaDettaglio" :readonly="isReadOnly" :disabled="jsonData.coneguirePatenteGuida !== 'SI'"></b-form-input>
                    <span v-else>{{ jsonData.coneguirePatenteGuidaDettaglio }}</span>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                    <label class="sa-label-data">Inserimento in un progetto lavoro seguito da DSM:</label>
                    <b-form-select :disabled="jsonData.attivitaInclusioneSocialeIntegrata !== 'SI'" v-if="!isReadOnly" v-model="jsonData.inserimentoProgettoLavoro" :options="options" text-field="text" value-field="value"></b-form-select>
                    <span v-else>{{ jsonData.inserimentoProgettoLavoro }}</span>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                    <label class="sa-label-data">Dettaglio:</label>
                    <b-form-input v-if="!isReadOnly" v-model="jsonData.inserimentoProgettoLavoroDettaglio" :readonly="isReadOnly" :disabled="jsonData.inserimentoProgettoLavoro !== 'SI'"></b-form-input>
                    <span v-else>{{ jsonData.inserimentoProgettoLavoroDettaglio }}</span>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                    <label class="sa-label-data">Inserimento lavorativo:</label>
                    <b-form-select :disabled="jsonData.attivitaInclusioneSocialeIntegrata !== 'SI'" v-if="!isReadOnly" v-model="jsonData.inserimentoLavorativo" :options="options" text-field="text" value-field="value"></b-form-select>
                    <span v-else>{{ jsonData.inserimentoLavorativo }}</span>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                    <label class="sa-label-data">Dettaglio:</label>
                    <b-form-input v-if="!isReadOnly" v-model="jsonData.inserimentoLavorativoDettaglio" :readonly="isReadOnly" :disabled="jsonData.inserimentoLavorativo !== 'SI'"></b-form-input>
                    <span v-else>{{ jsonData.inserimentoLavorativoDettaglio }}</span>
                </b-col>
            </b-row>
            <b-row>
                <b-col v-for="(data, index) in jsonData.listaDettagliAttivita" :key="index" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                    <label class="sa-label-data">Altro:</label>
                    <b-form-textarea v-if="!isReadOnly" v-model="jsonData.listaDettagliAttivita[index].dettaglio" rows="3" max-rows="6"></b-form-textarea>
                    <span v-else> {{ data.dettaglio }} </span>
                </b-col>
                <b-col v-if="!isReadOnly" cols="12" xs="12" sm="12" md="12" lg="12" xl="12" style="margin-top: 10px">
                    <b-button :disabled="jsonData.listaDettagliAttivita.length == 1" size="sm" variant="outline-danger outline-primary-noborder sa-margin-right float-sm-right" @click="onClickRimuovi" class="mb-2">
                        <i class="fas fa-minus"></i>
                        Rimuovi
                    </b-button>
                    <b-button size="sm" variant="outline-success outline-primary-noborder sa-margin-right float-sm-right" @click="onClickAggiungi" class="mb-2">
                        <i class="fas fa-plus"></i>
                        Aggiungi
                    </b-button>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                    <label class="sa-label-data">GRADUALE REINSERIMENTO NEL TESSUTO SOCIALE</label>
                    <b-form-select v-if="!isReadOnly" v-model="jsonData.gradualeReinserimentoTessutoSociale" :options="options" text-field="text" value-field="value"> </b-form-select>
                    <span v-else>{{ jsonData.gradualeReinserimentoTessutoSociale }}</span>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                    <label class="sa-label-data">Favorire il rientro in dfamiglia migliorando relazione e comunicazione con i familiari:</label>
                    <b-form-select :disabled="jsonData.gradualeReinserimentoTessutoSociale !== 'SI'" v-if="!isReadOnly" v-model="jsonData.favorireRientroFamiglia" :options="options" text-field="text" value-field="value"></b-form-select>
                    <span v-else>{{ jsonData.favorireRientroFamiglia }}</span>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                    <label class="sa-label-data">Dettaglio:</label>
                    <b-form-input v-if="!isReadOnly" v-model="jsonData.favorireRientroFamigliaDettaglio" :readonly="isReadOnly" :disabled="jsonData.favorireRientroFamiglia !== 'SI'"></b-form-input>
                    <span v-else>{{ jsonData.favorireRientroFamigliaDettaglio }}</span>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                    <label class="sa-label-data">Inserimento in struttura residenziale :</label>
                    <b-form-select :disabled="jsonData.gradualeReinserimentoTessutoSociale !== 'SI'" v-if="!isReadOnly" v-model="jsonData.inseriemntoStrutturaResidenziale" :options="options" text-field="text" value-field="value"></b-form-select>
                    <span v-else>{{ jsonData.inseriemntoStrutturaResidenziale }}</span>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                    <label class="sa-label-data">Dettaglio:</label>
                    <b-form-input v-if="!isReadOnly" v-model="jsonData.inseriemntoStrutturaResidenzialeDettaglio" :readonly="isReadOnly" :disabled="jsonData.inseriemntoStrutturaResidenziale !== 'SI'"></b-form-input>
                    <span v-else>{{ jsonData.inseriemntoStrutturaResidenzialeDettaglio }}</span>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                    <label class="sa-label-data">Iniziare e/o proseguire una vita in autonomia:</label>
                    <b-form-select :disabled="jsonData.gradualeReinserimentoTessutoSociale !== 'SI'" v-if="!isReadOnly" v-model="jsonData.iniziareProseguireVitaAutonomia" :options="options" text-field="text" value-field="value"></b-form-select>
                    <span v-else>{{ jsonData.iniziareProseguireVitaAutonomia }}</span>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                    <label class="sa-label-data">Dettaglio:</label>
                    <b-form-input v-if="!isReadOnly" v-model="jsonData.iniziareProseguireVitaAutonomiaDettaglio" :readonly="isReadOnly" :disabled="jsonData.iniziareProseguireVitaAutonomia !== 'SI'"></b-form-input>
                    <span v-else>{{ jsonData.iniziareProseguireVitaAutonomiaDettaglio }}</span>
                </b-col>
            </b-row>
            <b-row>
                <b-col v-for="(data, index) in jsonData.listaAttivitaReinserimento" :key="index" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                    <label class="sa-label-data">Altro:</label>
                    <b-form-textarea v-if="!isReadOnly" v-model="jsonData.listaAttivitaReinserimento[index].dettaglio" rows="3" max-rows="6"></b-form-textarea>
                    <span v-else> {{ data.dettaglio }} </span>
                </b-col>
                <b-col v-if="!isReadOnly" cols="12" xs="12" sm="12" md="12" lg="12" xl="12" style="margin-top: 10px">
                    <b-button :disabled="jsonData.listaAttivitaReinserimento.length == 1" size="sm" variant="outline-danger outline-primary-noborder sa-margin-right float-sm-right" @click="onClickRimuoviInserimento" class="mb-2">
                        <i class="fas fa-minus"></i>
                        Rimuovi
                    </b-button>
                    <b-button size="sm" variant="outline-success outline-primary-noborder sa-margin-right float-sm-right" @click="onClickAggiungiInserimento" class="mb-2">
                        <i class="fas fa-plus"></i>
                        Aggiungi
                    </b-button>
                </b-col>
            </b-row>
        </b-col>
    </b-row>
</template>
<script>
import UtilityMixin from "../../../utility/UtilityMixin";
import datePicker from "vue2-datepicker";

export default {
    components: { datePicker },
    mixins: [UtilityMixin],
    props: {
        idRisorsa: {
            type: String,
            default: function () {
                return null;
            },
        },
        idAccettazione: {
            type: String,
            default: function () {
                return null;
            },
        },
        isReadOnly: {
            type: Boolean,
        },
    },
    data() {
        return {
            options: [
                { value: null, text: "- Seleziona Valore -" },
                { value: "SI", text: "SI" },
                { value: "NO", text: "NO" },
            ],
            jsonData: {
                id: null,
                idAccettazione: null,
                dataInizio: null,
                dataFine: null,
                colloquiPeriodiciConFamiliari: null,
                colloquiPeriodiciConFamiliariDettaglio: null,
                attivitaInclusioneSocialeIntegrata: null,
                riprendereStudiConseguireLicenza: null,
                riprendereStudiConseguireLicenzaDettaglio: null,
                coneguirePatenteGuida: null,
                coneguirePatenteGuidaDettaglio: null,
                inserimentoProgettoLavoro: null,
                inserimentoProgettoLavoroDettaglio: null,
                inserimentoLavorativo: null,
                inserimentoLavorativoDettaglio: null,
                params: "",
                listaDettagliAttivita: [],
                gradualeReinserimentoTessutoSociale: null,
                favorireRientroFamiglia: null,
                favorireRientroFamigliaDettaglio: null,
                inseriemntoStrutturaResidenziale: null,
                inseriemntoStrutturaResidenzialeDettaglio: null,
                iniziareProseguireVitaAutonomia: null,
                iniziareProseguireVitaAutonomiaDettaglio: null,
                listaAttivitaReinserimento: [],
                nomeProgetto: "PROGETTO SOCIALE",
            },
            nomeProgetto: "PROGETTO SOCIALE",
            pathResourceProgettoSociale: "/rsapazientesrprogettosociale",
            params: "",
        };
    },
    watch: {
        "jsonData.colloquiPeriodiciConFamiliari"(v) {
            if (v !== "SI") {
                this.jsonData.colloquiPeriodiciConFamiliariDettaglio = null;
            }
        },
        "jsonData.riprendereStudiConseguireLicenza"(v) {
            if (v !== "SI") {
                this.jsonData.riprendereStudiConseguireLicenzaDettaglio = null;
            }
        },
        "jsonData.coneguirePatenteGuida"(v) {
            if (v !== "SI") {
                this.jsonData.coneguirePatenteGuidaDettaglio = null;
            }
        },
        "jsonData.inserimentoProgettoLavoro"(v) {
            if (v !== "SI") {
                this.jsonData.inserimentoProgettoLavoroDettaglio = null;
            }
        },
        "jsonData.inserimentoLavorativo"(v) {
            if (v !== "SI") {
                this.jsonData.inserimentoLavorativoDettaglio = null;
            }
        },
        "jsonData.favorireRientroFamiglia"(v) {
            if (v !== "SI") {
                this.jsonData.favorireRientroFamigliaDettaglio = null;
            }
        },
        "jsonData.inseriemntoStrutturaResidenziale"(v) {
            if (v !== "SI") {
                this.jsonData.inseriemntoStrutturaResidenzialeDettaglio = null;
            }
        },
        "jsonData.iniziareProseguireVitaAutonomia"(v) {
            if (v !== "SI") {
                this.jsonData.iniziareProseguireVitaAutonomiaDettaglio = null;
            }
        },
        "jsonData.attivitaInclusioneSocialeIntegrata"(v) {
            if (v !== "SI") {
                this.jsonData.riprendereStudiConseguireLicenza = "NO";
                this.jsonData.riprendereStudiConseguireLicenzaDettaglio = null;
                this.jsonData.coneguirePatenteGuida = "NO";
                this.jsonData.coneguirePatenteGuidaDettaglio = null;
                this.jsonData.inserimentoProgettoLavoro = "NO";
                this.jsonData.inserimentoProgettoLavoroDettaglio = null;
                this.jsonData.inserimentoLavorativo = "NO";
                this.jsonData.inserimentoLavorativoDettaglio = null;
                this.jsonData.listaDettagliAttivita = [];
            }
        },
        "jsonData.gradualeReinserimentoTessutoSociale"(v) {
            if (v !== "SI") {
                this.jsonData.favorireRientroFamiglia = "NO";
                this.jsonData.favorireRientroFamigliaDettaglio = null;
                this.jsonData.inseriemntoStrutturaResidenziale = "NO";
                this.jsonData.inseriemntoStrutturaResidenzialeDettaglio = null;
                this.jsonData.iniziareProseguireVitaAutonomia = "NO";
                this.jsonData.iniziareProseguireVitaAutonomiaDettaglio = null;
                this.jsonData.listaAttivitaReinserimento = [];
            }
        },
        jsonData: {
            handler(jsonData) {
                this.$emit("update", jsonData);
            },
            deep: true,
        },
    },
    mounted() {
        let me = this;
        me.idAccettazione = me.$route.query.idAccettazione ? me.$route.query.idAccettazione : me.$route.params.id;
        let params = { progettoSociale: "si" };
        me.params = JSON.stringify(params);
        me.jsonData.idAccettazione = me.idAccettazione;
        me.jsonData.params = me.params;
        me.jsonData.listaDettagliAttivita = [{ dettaglio: "" }];
        me.jsonData.listaAttivitaReinserimento = [{ dettaglio: "" }];
        me.jsonData.dataInizio = new Date().getTime();
        if (me.idRisorsa !== null) {
            me.loadData();
        }
    },
    methods: {
        loadData() {
            let me = this;
            UtilityMixin.methods.loadDataResources(me.pathResourceProgettoSociale + "/" + me.idRisorsa, {}, me.loadDataSuccess, me.loadDataError);
        },
        loadDataSuccess(response) {
            let me = this;
            me.jsonData = response.data.data;
            me.jsonData.nomeProgetto = me.nomeProgetto;
            me.jsonData.params = me.params;
            me.jsonData.idAccettazione = me.idAccettazione;
        },
        loadDataError(error) {
            console.log(error);
        },
        onClickAggiungi() {
            let me = this;
            me.jsonData.listaDettagliAttivita.push({ dettaglio: "" });
        },
        onClickRimuovi() {
            let me = this;
            me.jsonData.listaDettagliAttivita.pop();
        },
        onClickAggiungiInserimento() {
            let me = this;
            me.jsonData.listaAttivitaReinserimento.push({ dettaglio: "" });
        },
        onClickRimuoviInserimento() {
            let me = this;
            me.jsonData.listaAttivitaReinserimento.pop();
        },
    },
};
</script>
